<template>
  <d-container fluid class="px-4 main-content-container">
    <!-- Page Header -->
    <d-row no-gutters class="py-4 page-header">
      <div class="mb-0 text-center col-12 text-sm-left">
        <span class="text-uppercase page-subtitle d-block">Lista</span>
        <h3 class="page-title d-inline">Lojas Parceiras</h3>
        <router-link v-if="!isRepresentative" class="float-right text-white btn btn-success" :to="{ name: 'admin-reseller-new' }">Nova loja</router-link>
      </div>
    </d-row>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="mb-4 card-small">
          <div class="card-header border-bottom d-flex justify-content-start flex-wrap">
            <div class="col-6 col-md-6 mb-3 mb-md-0 px-2 col-xl-2">
              <h6 class="m-0 text-left">
                <span v-if="pagination.trashed">Lojas Inativas</span>
                <span v-else>Lojas Ativas</span>
              </h6>
            </div>
            <div class="col-6 col-md-6 mb-3 mb-md-0 px-2 col-xl-3">
              <label class="col-12">Mudar para</label>
              <d-button-group class="buttons">
                <d-button :class="['btn text-white float-right', !pagination.trashed? 'btn-danger' : 'btn-success']" @click="toggleTrashed">
                  <span v-if="pagination.trashed">Lojas Habilitadas</span>
                  <span v-else>Lojas Desabilitadas</span>
                </d-button>
                <d-button :class="['btn text-white float-right', pagination.status === 0 ? 'btn-info' : 'btn-secondary']" @click="toggleStatus">
                  <span v-if="pagination.status === 0">Lojas Ativas</span>
                  <span v-else>Lojas Inativas</span>
                </d-button>
              </d-button-group>
            </div>

            <div class="col-6 col-md-6 col-xl-3 px-2">
              <d-form-row>
                <d-col md="6" class="form-group">
                  <label for="feInputEstado">Estado</label>
                  <select-state :model.sync="pagination.state" :onChange="startCities"/>
                </d-col>
                <d-col md="6" class="form-group">
                  <label for="feInputEstado">Cidade</label>
                  <autocomplete
                    ref="city"
                    placeholder="Cidade"
                    item-show="city"
                    :items="cities"
                    :on-input="onInput"
                    :on-select="setCity"
                  ></autocomplete>
                </d-col>
              </d-form-row>
            </div>
            <div class="col-6 col-md-6 col-xl-3 px-2">
              <label class="col-12">Pesquisa</label>
              <form class="main-sidebar__search w-100 d-flex">
                <div class="ml-3 input-group input-group-seamless">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="fas fa-search"></i>
                    </div>
                  </div>
                  <input
                    class="navbar-search form-control"
                    type="text"
                    placeholder="Procurar por algo..."
                    aria-label="Search"
                    v-model="pagination.search"
                  />
                </div>
              </form>
            </div>
          </div>
          <div class="p-0 pb-3 text-left card-body">
            <div class="table-overflow">
              <reseller-table :resellers="resellers.list" />
            </div>
            <pagination
              :total-items="resellers.total_items"
              :pagination.sync="pagination"
              :event-name="paginationEvent"
            ></pagination>
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import SelectState from '_shared/SelectState.vue';
import Autocomplete from '_shared/Autocomplete.vue';
import ResellerService from '_services/rest/modules/reseller';
import ResellerTable from '../components/ResellerListTable.vue';

export default {
  name: 'reseller-list',
  components: {
    Pagination,
    SelectState,
    Autocomplete,
    ResellerTable,
  },
  data() {
    return {
      paginationEvent: 'PAGINATION:RESELLER',
      pagination: {
        trashed: 0,
        status: 1,
        search: '',
        state: '',
        city: '',
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
      cities: [],
      searchTimeoutId: null,
    };
  },
  computed: {
    resellers() {
      const { resellerList } = this.$store.state.reseller;
      if (resellerList && resellerList.list.length) {
        return resellerList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
    isRepresentative() {
      const { user } = this.$store.state.user;
      if (user && user.settings.type.slug === 'representative') {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getResellerList',
    ]),
    getList() {
      this.setToggle({ type: 'progress', bool: true });
      this.getResellerList(this.pagination)
        .then(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
    },
    toggleTrashed() {
      this.pagination.trashed = this.pagination.trashed === 1 ? 0 : 1;
    },
    toggleStatus() {
      this.pagination.status = this.pagination.status === 1 ? 0 : 1;
    },
    startCities() {
      this.onInput('');
    },
    onInput(search) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        const filter = {
          city: search,
          state: this.pagination.state,
        };
        ResellerService.getCities(filter)
          .then(response => {
            this.cities = response;
          });
      }, 500);
    },
    setCity(param) {
      this.pagination.city = param.city;
      this.getList();
    },
  },
  destroyed() {
    Events.$off(this.paginationEvent);
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on(this.paginationEvent, pagination => {
      if (pagination.page !== this.pagination.page) {
        this.$router.push({ params: { page: pagination.page } });
      }
      this.getList();
    });
    this.getList();
  },

};
</script>

<style lang="scss" scoped>
</style>
